import { IsEnum, IsNotEmpty, IsString } from "class-validator";

export enum IvaExemptionTypeEnumDto {
    yes = "yes",
    no = "no",
}

export class IvaExemptionTypeDto {
    @IsEnum(IvaExemptionTypeEnumDto)
    @IsNotEmpty()
    key!: IvaExemptionTypeEnumDto;

    @IsString()
    @IsNotEmpty()
    value!: string;
}